/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentFeesViewModel
 */
export interface InvestmentFeesViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentFeesViewModel
     */
    intermediaryAnnualServiceFee?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFeesViewModel
     */
    intermediaryAnnualServiceFeeSplit?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFeesViewModel
     */
    annualAdministrationFees?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFeesViewModel
     */
    recurringFeeSplit?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentFeesViewModel
     */
    investmentConsultingFee?: number;
}

/**
 * Check if a given object implements the InvestmentFeesViewModel interface.
 */
export function instanceOfInvestmentFeesViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentFeesViewModelFromJSON(json: any): InvestmentFeesViewModel {
    return InvestmentFeesViewModelFromJSONTyped(json, false);
}

export function InvestmentFeesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentFeesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intermediaryAnnualServiceFee': !exists(json, 'IntermediaryAnnualServiceFee') ? undefined : json['IntermediaryAnnualServiceFee'],
        'intermediaryAnnualServiceFeeSplit': !exists(json, 'IntermediaryAnnualServiceFeeSplit') ? undefined : json['IntermediaryAnnualServiceFeeSplit'],
        'annualAdministrationFees': !exists(json, 'AnnualAdministrationFees') ? undefined : json['AnnualAdministrationFees'],
        'recurringFeeSplit': !exists(json, 'RecurringFeeSplit') ? undefined : json['RecurringFeeSplit'],
        'investmentConsultingFee': !exists(json, 'InvestmentConsultingFee') ? undefined : json['InvestmentConsultingFee'],
    };
}

export function InvestmentFeesViewModelToJSON(value?: InvestmentFeesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IntermediaryAnnualServiceFee': value.intermediaryAnnualServiceFee,
        'IntermediaryAnnualServiceFeeSplit': value.intermediaryAnnualServiceFeeSplit,
        'AnnualAdministrationFees': value.annualAdministrationFees,
        'RecurringFeeSplit': value.recurringFeeSplit,
        'InvestmentConsultingFee': value.investmentConsultingFee,
    };
}

